/** Helyi állapot törlése — süti/PostHog/token crash loop után. */

import { CONSENT_COOKIE_NAME, CONSENT_STORAGE_KEY } from "@/lib/cookieConsent";

export const SAFE_MODE_KEY = "autopark_safe_mode";
export const CRASH_NEXT_BOOT_KEY = "autopark_crash_next_boot";
export const SKIP_ANALYTICS_GLOBAL = "__AUTOPARK_SKIP_ANALYTICS";

const LOCAL_KEYS = [
  "autopark_token",
  CONSENT_STORAGE_KEY,
  "autopark_visit_sid",
  "autopark_favorites",
  "autopark_favorite_deltas",
  "autopark_theme",
  "autopark_theme_user_set",
  "autopark_chunk_reload_v1",
  "autopark_oauth_token",
  "autopark_support_session",
  "autopark_support_history",
];

function consentCookieDomain() {
  if (typeof window === "undefined") return "";
  const h = window.location.hostname.toLowerCase();
  if (h === "autoparks.hu" || h.endsWith(".autoparks.hu")) return "; Domain=.autoparks.hu";
  return "";
}

function clearCookie(name) {
  if (typeof document === "undefined") return;
  const base = `${name}=; Path=/; Max-Age=0; SameSite=Lax`;
  document.cookie = base;
  document.cookie = `${base}; Secure${consentCookieDomain()}`;
}

export function isAnalyticsSafeMode() {
  if (typeof window === "undefined") return false;
  if (window[SKIP_ANALYTICS_GLOBAL]) return true;
  try {
    return localStorage.getItem(SAFE_MODE_KEY) === "1";
  } catch {
    return false;
  }
}

export function enableAnalyticsSafeMode() {
  if (typeof window === "undefined") return;
  window[SKIP_ANALYTICS_GLOBAL] = true;
  try {
    localStorage.setItem(SAFE_MODE_KEY, "1");
  } catch {
    /* ignore */
  }
}

export function clearAnalyticsSafeMode() {
  if (typeof window === "undefined") return;
  try {
    delete window[SKIP_ANALYTICS_GLOBAL];
  } catch {
    window[SKIP_ANALYTICS_GLOBAL] = undefined;
  }
  try {
    localStorage.removeItem(SAFE_MODE_KEY);
  } catch {
    /* ignore */
  }
}

export function sanitizeBrokenPosthogGlobal() {
  if (typeof window === "undefined") return;
  const ph = window.posthog;
  if (ph == null) return;
  if (typeof ph !== "object" || Array.isArray(ph)) {
    try {
      delete window.posthog;
    } catch {
      window.posthog = undefined;
    }
  }
}

/** App indulás előtt (index.js) — crash után safe mode, ?autopark_reset=1 */
export function runEarlyClientRecovery() {
  if (typeof window === "undefined") return;

  try {
    const q = new URLSearchParams(window.location.search);
    if (q.get("autopark_reset") === "1") {
      resetAutoparkClientState({ enableSafeMode: true });
      q.delete("autopark_reset");
      const qs = q.toString();
      window.history.replaceState(null, "", `${window.location.pathname}${qs ? `?${qs}` : ""}${window.location.hash}`);
      return;
    }
  } catch {
    /* ignore */
  }

  try {
    if (sessionStorage.getItem(CRASH_NEXT_BOOT_KEY) === "1") {
      sessionStorage.removeItem(CRASH_NEXT_BOOT_KEY);
      enableAnalyticsSafeMode();
    }
  } catch {
    /* ignore */
  }

  if (isAnalyticsSafeMode()) {
    window[SKIP_ANALYTICS_GLOBAL] = true;
  }

  sanitizeBrokenPosthogGlobal();
}

export function markCrashForNextBoot() {
  try {
    sessionStorage.setItem(CRASH_NEXT_BOOT_KEY, "1");
  } catch {
    /* ignore */
  }
}

/** Teljes helyi reset — kijelentkezés + süti + analytics safe mode. */
export function resetAutoparkClientState({ enableSafeMode = true } = {}) {
  if (typeof window === "undefined") return;

  for (const k of LOCAL_KEYS) {
    try {
      localStorage.removeItem(k);
    } catch {
      /* ignore */
    }
  }

  try {
    sessionStorage.removeItem("autopark_oauth_token");
    sessionStorage.removeItem(CRASH_NEXT_BOOT_KEY);
  } catch {
    /* ignore */
  }

  clearCookie("autopark_token");
  clearCookie(CONSENT_COOKIE_NAME);

  sanitizeBrokenPosthogGlobal();

  if (enableSafeMode) {
    enableAnalyticsSafeMode();
  }

  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister().catch(() => {}));
    }).catch(() => {});
  }
}
